import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/Pages/Home.vue';
import AboutPage from '@/components/Pages/About.vue';
import ProductPage from '@/components/Pages/Products.vue';
import ApplicationPage from '@/components/Pages/Application.vue';
import HonorPage from '@/components/Pages/Honor.vue';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { 
      hideTopBar: true,
      title: '瑜威电子科技 | 首页',
     }
  },
  {
    path: '/products',
    name: 'ProductPage',
    component: ProductPage,
    meta: { 
      title: '瑜威电子科技 | 模组方案',
    }

  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
    meta: { 
      title: '瑜威电子科技 | 联系我们',
    }
    
  },
  {
    path: '/application',
    name: 'ApplicationPage',
    component:  ApplicationPage,
    meta: { 
      title: '瑜威电子科技 | 应用场景',
    }
  },
  {
    path: '/honor',
    name: 'HonorPage',
    component: HonorPage,
    meta: { 
      title: '瑜威电子科技 | 荣誉展示',
    }
  }

  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '瑜威电子科技';
  if (to.path === '/application') {
    next(false); // 阻止跳转 到应用场景
  } else {
    next(); // 允许跳转
  }
});

export default router;
